import React from "react";
import bg1 from "../Images/Achievementbg.png";

const Achievement=()=>{

  const startDate = new Date("2008-09-03");
  const currentDate = new Date();

  // Calculate the years of experience
  const yearsOfExperience = currentDate.getFullYear() - startDate.getFullYear();
  const isAnniversaryPassed =
    currentDate.getMonth() > startDate.getMonth() ||
    (currentDate.getMonth() === startDate.getMonth() &&
      currentDate.getDate() >= startDate.getDate());
  const totalExperience = isAnniversaryPassed ? yearsOfExperience : yearsOfExperience - 1;

    return(
<section
    className="ftco-section ftco-counter img"
    id="section-counter"
    style={{ backgroundImage: `url(${bg1})` }}
  >
    <div className="overlay" />
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div className="row">
            <div className="col-md-6 col-lg-3 d-flex justify-content-center counter-wrap ftco-animate">
              <div className="block-18 text-center">
                <div className="text">
                  <div className="icon">
                    <span className="flaticon-flower" />
                  </div>
                  <span>Happy Client</span>
                  <strong className="number" data-number={3500}>
                    10000
                  </strong>
                </div>
              </div>
            </div>
           
            <div className="col-md-6 col-lg-3 d-flex justify-content-center counter-wrap ftco-animate">
              <div className="block-18 text-center">
                <div className="text">
                  <div className="icon">
                    <span className="flaticon-flower" />
                  </div>
                  <span>Satisfication</span>
                  <strong className="number" data-number={3000}>
                    25000
                  </strong>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 d-flex justify-content-center counter-wrap ftco-animate">
              <div className="block-18 text-center">
                <div className="text">
                  <div className="icon">
                    <span className="flaticon-flower" />
                  </div>
                  <span>Years of Experience</span>
                  <strong className="number" data-number={900}>
                    {totalExperience}+
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
    );
}

export default Achievement;